/* Xerjoff-style hybrid scroll controller for AGCA'S PARFUM
   First N sections: stacked full-screen panels with scroll-hijacking
   Remaining sections: normal page scroll */
(function () {
  'use strict';

  if (!document.body.classList.contains('index')) return;
  if (window.innerWidth < 1024) return;

  var STACKED_COUNT = 2;
  var TRANSITION_MS = 600;
  var WHEEL_THRESHOLD = 80;
  var COOLDOWN_MS = 300;

  var container = null;
  var allSections = [];
  var panels = [];
  var currentIndex = 0;
  var isTransitioning = false;
  var wheelAccumulator = 0;
  var wheelTimer = null;
  var cooldownTimer = null;
  var inCooldown = false;
  var progressNav = null;
  var progressDots = [];
  var mode = 'stacked';

  function init() {
    container = document.querySelector('.content-for-layout');
    if (!container) return;

    allSections = Array.from(container.querySelectorAll(':scope > .shopify-section'));
    if (allSections.length === 0) return;

    panels = allSections.slice(0, STACKED_COUNT);
    panels.forEach(function (s) { s.classList.add('xj-panel'); });
    panels[0].classList.add('xj-first', 'xj-active', 'xj-visible');

    document.body.classList.add('xj-stacked');

    createProgress();
    bindEvents();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.body.classList.add('xj-ready');
      });
    });
  }

  /* ── Progress dots ── */

  function createProgress() {
    progressNav = document.createElement('div');
    progressNav.className = 'xj-progress';
    panels.forEach(function (_, i) {
      var dot = document.createElement('div');
      dot.className = 'xj-progress__dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', function () { goTo(i); });
      progressNav.appendChild(dot);
      progressDots.push(dot);
    });
    document.body.appendChild(progressNav);
  }

  function updateProgress() {
    progressDots.forEach(function (d, i) {
      d.classList.toggle('active', i === currentIndex);
    });
  }

  /* ── Force reflow on text elements to re-trigger CSS transitions ── */

  function resetTextAnimations(panel) {
    var els = panel.querySelectorAll(
      '.banner__content .subheading, .banner__content .heading, ' +
      '.banner__content .rte, .banner__content .btn-wrapper, ' +
      '.banner__content [class*="btn"], .multi-content > .grid > *'
    );
    els.forEach(function (el) {
      el.style.transition = 'none';
      el.style.opacity = '0';
      el.style.transform = 'translateY(40px)';
      void el.offsetHeight;
      el.style.transition = '';
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  /* ── Start cooldown after transition ── */

  function startCooldown() {
    inCooldown = true;
    wheelAccumulator = 0;
    clearTimeout(cooldownTimer);
    cooldownTimer = setTimeout(function () {
      inCooldown = false;
      wheelAccumulator = 0;
    }, COOLDOWN_MS);
  }

  /* ── Panel transitions (stacked mode) ── */

  function goTo(index) {
    if (index === currentIndex || isTransitioning || inCooldown) return;
    if (index < 0 || index >= panels.length) return;

    isTransitioning = true;
    wheelAccumulator = 0;

    var oldPanel = panels[currentIndex];
    var newPanel = panels[index];

    resetTextAnimations(newPanel);

    if (index > currentIndex) {
      newPanel.style.transform = 'translateY(100%)';
      newPanel.style.transition = 'none';
      void newPanel.offsetHeight;
      newPanel.style.transition = '';
      newPanel.classList.add('xj-active');

      requestAnimationFrame(function () {
        newPanel.style.transform = 'translateY(0)';
      });
    } else {
      oldPanel.style.zIndex = '2';
      newPanel.classList.add('xj-active');
      newPanel.style.transform = 'translateY(0)';
      newPanel.style.transition = 'none';
      void newPanel.offsetHeight;
      newPanel.style.transition = '';

      requestAnimationFrame(function () {
        oldPanel.style.transform = 'translateY(100%)';
      });
    }

    setTimeout(function () {
      panels.forEach(function (s, i) {
        if (i !== index) {
          s.classList.remove('xj-active', 'xj-visible');
          s.style.zIndex = '';
          s.style.transform = '';
          s.style.transition = '';
        }
      });

      newPanel.classList.add('xj-visible');
      newPanel.style.zIndex = '';

      if (index === 0) {
        newPanel.classList.add('xj-first');
      } else {
        newPanel.classList.remove('xj-first');
      }

      currentIndex = index;
      updateProgress();
      isTransitioning = false;
      startCooldown();
    }, TRANSITION_MS);
  }

  /* ── Animated mode switching ── */

  function enterNormalMode() {
    if (mode === 'normal' || isTransitioning || inCooldown) return;
    isTransitioning = true;
    wheelAccumulator = 0;

    var lastPanel = panels[currentIndex];

    document.body.classList.remove('xj-stacked');
    document.body.classList.add('xj-normal');
    window.scrollTo(0, 0);

    lastPanel.classList.add('xj-exit');
    lastPanel.style.transform = 'translateY(0)';
    lastPanel.style.transition = 'none';
    void lastPanel.offsetHeight;
    lastPanel.style.transition = '';

    requestAnimationFrame(function () {
      lastPanel.style.transform = 'translateY(-100%)';
    });

    setTimeout(function () {
      lastPanel.classList.remove('xj-exit', 'xj-active', 'xj-visible', 'xj-first');
      lastPanel.style.transform = '';
      lastPanel.style.transition = '';
      lastPanel.style.zIndex = '';
      mode = 'normal';
      isTransitioning = false;
      startCooldown();
    }, TRANSITION_MS);
  }

  function enterStackedMode() {
    if (mode === 'stacked' || isTransitioning || inCooldown) return;
    isTransitioning = true;
    wheelAccumulator = 0;

    var lastPanel = panels[panels.length - 1];

    resetTextAnimations(lastPanel);

    lastPanel.classList.add('xj-enter');
    lastPanel.style.transform = 'translateY(-100%)';
    lastPanel.style.transition = 'none';
    void lastPanel.offsetHeight;
    lastPanel.style.transition = '';

    requestAnimationFrame(function () {
      lastPanel.style.transform = 'translateY(0)';
    });

    setTimeout(function () {
      lastPanel.classList.remove('xj-enter');
      lastPanel.style.transform = '';
      lastPanel.style.transition = '';
      lastPanel.style.zIndex = '';

      document.body.classList.remove('xj-normal');
      document.body.classList.add('xj-stacked');

      currentIndex = panels.length - 1;
      panels.forEach(function (s) {
        s.classList.remove('xj-active', 'xj-visible', 'xj-first');
        s.style.transform = '';
        s.style.transition = '';
        s.style.zIndex = '';
      });
      panels[currentIndex].classList.add('xj-active', 'xj-visible');
      if (currentIndex === 0) panels[0].classList.add('xj-first');
      updateProgress();

      mode = 'stacked';
      isTransitioning = false;
      startCooldown();
    }, TRANSITION_MS);
  }

  /* ── Wheel handling ── */

  function onWheel(e) {
    if (isTransitioning || inCooldown) {
      e.preventDefault();
      return;
    }

    if (mode === 'stacked') {
      e.preventDefault();

      wheelAccumulator += e.deltaY;
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () { wheelAccumulator = 0; }, 200);

      if (Math.abs(wheelAccumulator) >= WHEEL_THRESHOLD) {
        if (wheelAccumulator > 0) {
          if (currentIndex < panels.length - 1) {
            goTo(currentIndex + 1);
          } else {
            enterNormalMode();
          }
        } else {
          if (currentIndex > 0) {
            goTo(currentIndex - 1);
          }
        }
        wheelAccumulator = 0;
      }
      return;
    }

    if (mode === 'normal' && window.scrollY <= 0 && e.deltaY < 0) {
      e.preventDefault();

      wheelAccumulator += e.deltaY;
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () { wheelAccumulator = 0; }, 200);

      if (Math.abs(wheelAccumulator) >= WHEEL_THRESHOLD) {
        enterStackedMode();
        wheelAccumulator = 0;
      }
    }
  }

  /* ── Touch handling ── */

  var touchStartY = 0;

  function onTouchStart(e) {
    touchStartY = e.touches[0].clientY;
  }

  function onTouchEnd(e) {
    if (isTransitioning || inCooldown) return;
    var diff = touchStartY - e.changedTouches[0].clientY;

    if (mode === 'stacked') {
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          if (currentIndex < panels.length - 1) {
            goTo(currentIndex + 1);
          } else {
            enterNormalMode();
          }
        } else {
          if (currentIndex > 0) {
            goTo(currentIndex - 1);
          }
        }
      }
      return;
    }

    if (mode === 'normal' && window.scrollY <= 0 && diff < -50) {
      enterStackedMode();
    }
  }

  /* ── Keyboard handling ── */

  function onKeyDown(e) {
    if (isTransitioning || inCooldown) return;

    if (mode === 'stacked') {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        e.preventDefault();
        if (currentIndex < panels.length - 1) {
          goTo(currentIndex + 1);
        } else {
          enterNormalMode();
        }
      }
      if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        if (currentIndex > 0) goTo(currentIndex - 1);
      }
      if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      if (e.key === 'End') { e.preventDefault(); enterNormalMode(); }
    }
  }

  /* ── Event binding ── */

  function bindEvents() {
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('keydown', onKeyDown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
